import styles from '../index.scss'
import { useState } from 'react'
import { province_board, mix_board } from './data'
import classnames from 'classnames'
import DpBusinessPopup from '@/libs/components/DpBusinessComponents/DpBusinessPopup'
import { Toast } from 'antd-mobile'
import { DelSvg } from './svgIcon'

type PropsType = {
  updateVisible?: (type: boolean) => void
  onChange?: (value: any[]) => void
  visible?: Boolean
  value?: any[]
}

const AreaNumber = (props: PropsType) => {
  const [type, updateType] = useState(0)
  const [value, updateValue] = useState(props?.value || ['', ''])
  const funName = ["清空", "省份", "ABC", "删除", "退格"];
  return (
    <>
      <DpBusinessPopup
        visible={!!props?.visible}
        type={'picker'}
        onClose={() => props?.updateVisible?.(false)}
        title={'已选择：' + value?.join('')}
        headerStyle={{
          borderBottomWidth: 0,
          color: 'var(--text-color, #222222)',
          background: 'var(--page-bg-color, #F5F6F8)'
        }}
        titleStyle={{
          color: 'var(--text-color, #222222)',
          textAlign: 'center',
        }}
        bodyStyle={{
          paddingBottom: 0,
          background: 'var(--page-bg-color, #F5F6F8)'
        }}
        popupBodyStyles={{
          background: 'var(--page-bg-color, #F5F6F8)',
          maxHeight: '100vh',
          minHeight: '10vh',
        }}
        containerStyles={{ padding: "4px 6px 12px", background: 'var(--page-bg-color, #F5F6F8)'  }}
        onConfirm={() => {
          if (value?.filter((_: string) => _)?.length && (!value?.[0] || !value?.[1])) {
            Toast.show({
              content: '请完整选择区码'
            })
          } else {
            props?.onChange?.(value)
          }
        }}
      >
        <div className="boardMain">
          {(type === 0 ? province_board : mix_board).map((item, index) => {
            return (
              <div className={styles["keyboard_content"]} key={index}>
                {item.map((item_key, index_key) => {
                  return (
                    <div
                      className={
                        classnames([styles['mix'], { [styles['mix_fun']]: funName.includes(item_key) } ])
                      }
                      key={"col_" + item_key + index_key}
                      onClick={() => {
                        // if (item_key === '清空') {
                        //   updateValue(['', ''])
                        //   updateType(0)
                        //   return
                        // }
                        if (item_key === '退格') {
                          if (value[1]) {
                            updateValue([value?.[0] || '', ''])
                          } else [
                            updateValue(['','']),
                            updateType(0)
                          ]
                          return
                        }
                        if (item_key === 'ABC') {
                          if (!value[0]) {
                            Toast.show({
                              content: '请先选择省市编码',
                            })
                            return
                          }
                          updateType(1)
                          return
                        }
                        if (item_key === '省份') {
                          updateType(0)
                          return
                        }
                        let _value = [...value]
                        _value[type] = item_key
                        updateValue(_value)
                        if (type === 0) {
                          updateType((pve) => pve + 1)
                        } else {
                          if (_value?.[0] && _value?.[1]) {
                            props?.onChange?.(_value)
                          }
                        }
                      }}
                    >
                      {
                        item_key === '退格' ? <DelSvg /> : item_key
                      }
                    </div>
                  );
                })}
              </div>
            );
          })}
        </div>
      </DpBusinessPopup>
    </>
  )
}

export default AreaNumber
